export const addsubcategorytranslation = {
  cz: {
    title: "Přidat podkategorii",
    name: "Název podkategorie",
    subcategorySuccess: "Podkategorie byla úspěšně přidána",
    discard: "Zahodit",
    save: "Uložit",
    details: "Detaily",
    categories: "Kategorie",
  },
  en: {
    title: "Add Subcategory",
    name: "Subcategory Name",
    subcategorySuccess: "Subcategory added successfully",
    discard: "Discard",
    save: "Save",
    details: "Details",
    categories: "Categories",
  },
  de: {
    title: "Unterkategorie hinzufügen",
    name: "Name der Unterkategorie",
    subcategorySuccess: "Unterkategorie erfolgreich hinzugefügt",
    discard: "Verwerfen",
    save: "Speichern",
    details: "Details",
    categories: "Kategorien",
  },
  es: {
    title: "Añadir subcategoría",
    name: "Nombre de la subcategoría",
    subcategorySuccess: "Subcategoría añadida con éxito",
    discard: "Descartar",
    save: "Guardar",
    details: "Detalles",
    categories: "Categorías",
  },
  fr: {
    title: "Ajouter une sous-catégorie",
    name: "Nom de la sous-catégorie",
    subcategorySuccess: "Sous-catégorie ajoutée avec succès",
    discard: "Annuler",
    save: "Enregistrer",
    details: "Détails",
    categories: "Catégories",
  },
  hu: {
    title: "Alkategória hozzáadása",
    name: "Alkategória neve",
    subcategorySuccess: "Az alkategória sikeresen hozzáadva",
    discard: "Elvetés",
    save: "Mentés",
    details: "Részletek",
    categories: "Kategóriák",
  },
  nl: {
    title: "Subcategorie toevoegen",
    name: "Naam van de subcategorie",
    subcategorySuccess: "Subcategorie succesvol toegevoegd",
    discard: "Annuleren",
    save: "Opslaan",
    details: "Details",
    categories: "Categorieën",
  },
  pl: {
    title: "Dodaj podkategorię",
    name: "Nazwa podkategorii",
    subcategorySuccess: "Podkategoria została pomyślnie dodana",
    discard: "Odrzuć",
    save: "Zapisz",
    details: "Szczegóły",
    categories: "Kategorie",
  },
  ru: {
    title: "Добавить подкатегорию",
    name: "Название подкатегории",
    subcategorySuccess: "Подкатегория успешно добавлена",
    discard: "Отменить",
    save: "Сохранить",
    details: "Детали",
    categories: "Категории",
  },
  sk: {
    title: "Pridať podkategóriu",
    name: "Názov podkategórie",
    subcategorySuccess: "Podkategória bola úspešne pridaná",
    discard: "Zahodiť",
    save: "Uložiť",
    details: "Detaily",
    categories: "Kategórie",
  },
  sv: {
    title: "Lägg till underkategori",
    name: "Namn på underkategori",
    subcategorySuccess: "Underkategori tillagd framgångsrikt",
    discard: "Kassera",
    save: "Spara",
    details: "Detaljer",
    categories: "Kategorier",
  },
  no: {
    title: "Legg til underkategori",
    name: "Navn på underkategori",
    subcategorySuccess: "Underkategori lagt til",
    discard: "Forkast",
    save: "Lagre",
    details: "Detaljer",
    categories: "Kategorier",
  },
  da: {
    title: "Tilføj underkategori",
    name: "Navn på underkategori",
    subcategorySuccess: "Underkategori tilføjet",
    discard: "Kassér",
    save: "Gem",
    details: "Detaljer",
    categories: "Kategorier",
  },
  fi: {
    title: "Lisää alikategoria",
    name: "Alikategorian nimi",
    subcategorySuccess: "Alikategoria lisätty onnistuneesti",
    discard: "Hylkää",
    save: "Tallenna",
    details: "Tiedot",
    categories: "Kategoriat",
  },
  ar: {
    title: "إضافة فئة فرعية",
    name: "اسم الفئة الفرعية",
    subcategorySuccess: "تمت إضافة الفئة الفرعية بنجاح",
    discard: "تجاهل",
    save: "حفظ",
    details: "التفاصيل",
    categories: "الفئات",
  },
};

export default addsubcategorytranslation;
